import Modal from 'bootstrap/js/src/modal'

// « Prendre rendez-vous » : ouvre le formulaire dans une modale, sans quitter la page.
// Cibles : liens vers #rendez-vous, liens .js-appointment-modal, et tout lien « rendez-vous » vers la page contact
// (boutons saisis dans les contenus du BO).
const APPOINTMENT_HASH = '#rendez-vous'

function getModal() {
  const modalEl = document.getElementById('modal-rendez-vous')

  return modalEl ? Modal.getOrCreateInstance(modalEl) : null
}

document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href]')
  const modalEl = document.getElementById('modal-rendez-vous')
  if (!modalEl || !link || e.defaultPrevented) {
    return
  }

  const linkUrl = new URL(link.href, window.location.href)
  const isAppointmentLink = linkUrl.hash === APPOINTMENT_HASH ||
    link.classList.contains('js-appointment-modal') ||
    linkUrl.pathname === modalEl.dataset.contactPath && /rendez-vous/i.test(link.textContent)

  if (!isAppointmentLink) {
    return
  }

  e.preventDefault()
  getModal().show()
})

// lien direct vers …#rendez-vous : ouverture au chargement
if (window.location.hash === APPOINTMENT_HASH) {
  window.addEventListener('load', () => getModal()?.show())
}
